import Modal from '@mui/material/Modal'
import CircularProgress from '@mui/material/CircularProgress'
import strings from '../../res/strings'

const LoadingModal = () => {
    return (
        <Modal
            className='flex items-center justify-center'
            disableAutoFocus={true}
            open={true}
        >
            <div className='flex flex-col items-center'>

                <CircularProgress size='4rem' style={{ color: 'white' }} />
                
                <p className='font-montserrat text-lg font-bold text-center text-white mt-[1.125rem]'>{strings.wait}</p>

            </div>
        </Modal>
    )
}

export default LoadingModal